import { getRecentlyViewedProductIds, persistRecentlyViewedProducts } from '@theme/recently-viewed-products-persistor';

/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store, should stay in sync with sections/recently-viewed-product-list.liquid */
  static #MAX_PRODUCTS = 16;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    persistRecentlyViewedProducts(this.getProducts()).then();
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    persistRecentlyViewedProducts(this.getProducts()).then();
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static getProductsFromServer() {
    return getRecentlyViewedProductIds();
  }
}
